import { render, staticRenderFns } from "./bonuslist.vue?vue&type=template&id=fc1f6ba0&scoped=true"
import script from "./bonuslist.vue?vue&type=script&lang=js"
export * from "./bonuslist.vue?vue&type=script&lang=js"
import style0 from "./bonuslist.vue?vue&type=style&index=0&id=fc1f6ba0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1f6ba0",
  null
  
)

export default component.exports